// extracted by mini-css-extract-plugin
module.exports = {"img":"UserDetails_img__1x7mX","htext":"UserDetails_htext__1LZRf","number":"UserDetails_number__5RTqr","carIcon":"UserDetails_carIcon__3fmR_","inp":"UserDetails_inp__1-oHM"};